import React, { useState, useContext } from "react";
import { AdminContext } from "../Contexts/AdminContext";
import { useNavigate } from "react-router-dom";

const SignIn = () => {
  const navigate = useNavigate();
  const { login, error } = useContext(AdminContext);
  const [credentials, setCredentials] = useState({
    userName: "",
    password: "",
  });
  const [loginError, setLoginError] = useState(null);
  const [loginSuccess, setLoginSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(credentials);
      setLoginError(null);
      setLoginSuccess(true);
      // Redirect or perform additional actions upon successful login
      navigate("/admin/dashboard");
    } catch (err) {
      setLoginError("Invalid credentials. Please try again.");
      setLoginSuccess(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 py-6 flex flex-col justify-center sm:py-12">
      <div className="relative py-3 sm:max-w-xl sm:mx-auto">
        <div className="absolute inset-0 bg-gradient-to-r from-primary to-sky-500 shadow-lg transform -skew-y-6 sm:skew-y-0 sm:-rotate-6 sm:rounded-3xl"></div>
        <div className="relative px-4 py-10 bg-white shadow-lg sm:rounded-3xl sm:p-20">
          <div className="max-w-md mx-auto">
            <div>
              <h1 className="text-2xl font-bold text-primary text-center sm:text-3xl sm:text-left">
                SAWA
              </h1>
            </div>

            <div className="divide-y divide-gray-200">
              <form
                onSubmit={handleSubmit}
                className="py-8 text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7"
              >
                <div className="relative">
                  <input
                    autoComplete="off"
                    id="userName"
                    name="userName"
                    type="text"
                    className="peer placeholder-transparent h-10 w-full border-b-2 border-gray-300 text-gray-900 focus:outline-none focus:border-rose-600 bg-white"
                    placeholder=""
                    value={credentials.userName}
                    onChange={handleChange}
                  />
                  <label
                    htmlFor="userName"
                    className="absolute left-0 -top-3.5 text-gray-600 text-sm peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-440 peer-placeholder-shown:top-2 transition-all peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
                  >
                    User Name
                  </label>
                </div>
                <div className="relative">
                  <input
                    autoComplete="off"
                    id="password"
                    name="password"
                    type="password"
                    className="peer placeholder-transparent h-10 w-full border-b-2 border-gray-300 text-gray-900 focus:outline-none focus:border-rose-600 bg-white"
                    placeholder=""
                    value={credentials.password}
                    onChange={handleChange}
                  />
                  <label
                    htmlFor="password"
                    className="absolute left-0 -top-3.5 text-gray-600 text-sm peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-440 peer-placeholder-shown:top-2 transition-all peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
                  >
                    Password
                  </label>
                </div>
                <div className="relative">
                  <button className="flex items-center justify-center px-6 py-2 mt-4 font-medium text-white bg-primary hover:bg-sky-600 transition">
                    Login
                  </button>
                </div>
              </form>
            </div>
            {loginSuccess ? (
              <p className="text-green-500 mt-4">Login successful!</p>
            ) : (
              loginError && <p className="text-red-500 mt-4">{loginError}</p>
            )}
            {error && !loginSuccess && <p className="text-red-500 mt-4">{error}</p>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
